// temp solution until a proper versioning
export const UFO_BUILD_VERSION = '0.1.7';
